module.exports = __webpack_public_path__ + "img/mp1.3059eec2.png";